import React, { useState, useEffect } from "react";
import Selphi from "./Selphi";
import SelphID from "./SelphID";
import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import {
  setBirthdate,
  setCity,
  setFullName,
  setGender,
  setIdNumber,
  setIdExpiryDate,
  setIdPictureBase64,
  setShouldFacePhiApply,
  setNationality,
  setIdPictureExtension,
  setShouldFourthStepBeSkipped,
  setDocNumber,
  setCountryCode,
  incrementCurrentRegistrationStep,
  selectRegistrationState,
} from "../../../features/registration/registrationSlice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { setOperationId, setSessionId } from "../../../features/utilities/utilitySlice";
import { defineCustomElements } from "@facephi/sdk-web-wc/loader";
import { SdkProvider, useTracking, TrackingSteps, TrackingStatus } from "@facephi/sdk-web";
import { selectLoginState } from "../../../features/login/loginSlice";
import { TypeFamily } from "@facephi/sdk-web/dist/sdk-web";

defineCustomElements(window);

const FacephiFlow = ({ onSelphiComplete, onSelphIdComplete, isUanataca }) => {
  const { trackingStart, trackingStatus, trackingEvent, operationId, sessionId } = useTracking();
  const [bestImageCropped, setBestImageCropped] = useState(null);
  const [extractionResult, setExtractionResult] = useState(null);
  const dispatch = useDispatch();
  const loginSlice = useSelector(selectLoginState);
  const registrationSliceState = useSelector(selectRegistrationState);
  // const trackingUrl = import.meta.env.VITE_API_TRACKING;
  // const clientId = import.meta.env.VITE_CLIENTID_TRACKING;
  // const clientSecret = import.meta.env.VITE_CLIENTSECRET_TRACKING;
  // const authUrl = import.meta.env.VITE_AUTH_API_URL;
  // const tenantId = import.meta.env.VITE_TENANT_ID;
  // const trackingUrlAssets = import.meta.env.VITE_API_ASSETS;

  const handleBestImageCropped = (bestImageCropped) => {
    setBestImageCropped(bestImageCropped);


    if(onSelphiComplete !== undefined) {
      onSelphiComplete(bestImageCropped != null)
    }
  };

  const parseDate = async (input) => {
    const parsedDate = moment(input, "YYMMDD");
    const formattedDate = parsedDate.format("DD/MM/YYYY");
    return formattedDate;
  };

  const getPersonalNr = (selphIDResult) => {
    let personalNr
    if (selphIDResult.detail.extractionData.documentCountryIssuer === 'ALB') {
      personalNr = selphIDResult.detail.extractionData.documentId
    }
    else personalNr = `${selphIDResult.detail.extractionData.documentCountryIssuer}-${selphIDResult.detail.extractionData.documentNumber}`

    return personalNr
  }

  const handleDataRetrieved = async (extractionResult) => {

    if (onSelphIdComplete !== undefined) {
      onSelphIdComplete(extractionResult !== null)
    }

    if (extractionResult !== null) {
      setExtractionResult(extractionResult);
      const birthday = await parseDate(extractionResult.detail.extractionData.dateOfBirth);
      const expiryDate = await parseDate(extractionResult.detail.extractionData.dateOfExpiry);
      let fullName = extractionResult.detail.extractionData.firstName + " " + extractionResult.detail.extractionData.lastName;
      if (extractionResult.detail.extractionData.documentCountryIssuer === 'GRC') {
        const temp = fullName.split(" ").filter(item => item !== "OR");
        if (temp.length === 4) {
          fullName = temp[0] + ' ' + temp[2];
        }
      }
      dispatch(setBirthdate(birthday));
      dispatch(setGender(extractionResult.detail.extractionData.gender));
      dispatch(setFullName(fullName));
      dispatch(setIdNumber(getPersonalNr(extractionResult)));
      dispatch(setIdExpiryDate(expiryDate));
      dispatch(setIdPictureBase64(extractionResult.detail.images.frontDocument));
      dispatch(setNationality(extractionResult.detail.extractionData.nationality));
      dispatch(setIdPictureExtension("jpg"));
      dispatch(setCity(extractionResult.detail.extractionData.placeOfBirth));
      dispatch(setDocNumber(extractionResult.detail.extractionData.documentNumber));
      dispatch(setCountryCode(extractionResult.detail.extractionData.documentCountryIssuer));
      dispatch(setShouldFacePhiApply(true));
      dispatch(setShouldFourthStepBeSkipped(true));
      if (registrationSliceState.isUpgrading) dispatch(incrementCurrentRegistrationStep());
    }
    else setExtractionResult(null);
  };

  const useStyles = makeStyles((theme) => ({
    gridContainer: {
      height: "500px",
      width: "1000px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "-90px",
      "@media (min-width: 1300px)": {
        marginLeft: "400px",
        marginRight: "400px",
      },
    },
  }));
  const classes = useStyles();

  return (
    <>
      <SdkProvider  
          bundlePath={ window.location.origin + "/widgets"}
          trackingOptions={{
          authUrl: 'https://identity-platform.easypay.al/auth/realms/inphinite/protocol/openid-connect/token',
          clientId: 'sdk-web',
          clientSecret: 'dMZiXtqd01p5NW41NU5k4kMmlJ5ypKGl',
          trackingUrl: 'https://identity-platform.easypay.al/api/tracking/events',
          trackingUrlAssets: 'https://identity-platform.easypay.al/api/assets/',
          tenantId: 'e9b039fa-0a2f-4149-9acc-a7e20a46464e',
        type: TypeFamily.onboarding
        }}
        customerId={loginSlice.username}
   
      >
        {(extractionResult === null && bestImageCropped !== null) &&
          <Grid container xs={12} md={12} className={classes.gridContainer}>
            <SelphID onDataRetrievement={handleDataRetrieved} isUanataca={isUanataca} />
          </Grid>
        }

        {(bestImageCropped === null) &&
          <Selphi onBestImageCropped={handleBestImageCropped} />
        }
      </SdkProvider>
    </>
  );
}; 

export default FacephiFlow;
